import { CenterData, Page } from '@/types/models'

export const parseCenterId = ({
  pageType,
  center
}: {
  pageType: Page
  center: CenterData & { pid: number }
}): number => {
  if (
    pageType === Page.BROWSE ||
    pageType === Page.FAVORITES ||
    pageType.includes(Page.FACET_LOCATION)
  ) {
    if (center?.feedType === 'midFeed' && center?.certifications?.length > 0) {
      return parseInt(center?.certifications[0]?.centerId)
    }
    return parseInt(center?.id)
  }

  return center?.pid
}
